import { FC } from 'react';
import { CloseButtonStyled } from './style';
import { Props } from './types';

const CloseButton: FC<Props> = ({ onClick, isFullscreen }) => (
  <CloseButtonStyled onClick={onClick} isFullscreen={isFullscreen}>
    <i className="fas fa-times" />
  </CloseButtonStyled>
);

export default CloseButton;
